<template src="./tabla.html">
    
</template>
<script>
export default {
    
}
</script>
<style src="./tabla.scss" lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Gestion/gestionRehabilitacion/tabla/tabla.vue